import { GuestGuard } from '../guards/RolesGuard';
import Login from '../features/auth/login';
import Register from '../features/auth/register';
import ResetPassword from '../features/auth/reset-password';
import Layout from '../container/Layout';
import { UserGuard } from '../guards/UserGuard';
import Faqs from '../features/dashboard/faqs/Faqs';
import Homepage from '../features/dashboard/dashboards-options';
import MarketingView from '../features/dashboard/dashboards-options/MarketingView';
import AiModels from '../features/dashboard/ai-models';
import DemoRequests from '../features/dashboard/demo-requests';
import KnowledgeBaseExceptionsTester from '../features/dashboard/sofia/exceptions/KnowledgeBaseExceptionsTester';
import ClientCostsPage from '../features/dashboard/costs';
import ClientCostsDetailsPage from '../features/dashboard/costs/details';
import UsersNeedHelp from '../features/dashboard/need-help';
import UsersPage from '../features/dashboard/users';
import AgentClientsPage from '../features/dashboard/agent-clients';
import LeoSubscriptionsPage from '../features/dashboard/subscriptions';
import PromptsListPage from '../features/dashboard/prompts';
import CreatePromptPage from '../features/dashboard/prompts/CreatePrompt';
import PromptDetailPage from '../features/dashboard/prompts/PromptDetail';
import LeoComparisonBoards from '../features/dashboard/comparison-boards';
import LeoChatPage from '../features/dashboard/leo-chat';
import ExpertPartners from '../features/dashboard/expert-partners';
import ClaireGlenIvy from '../features/dashboard/claire-glen-ivy';
import TipsFeedback from '../features/dashboard/tips-feedback';
// import WelcomePage from '../features/auth/welcome';

export interface RouteDefinition {
    path: string;
    element: JSX.Element;
    guard?: () => boolean;
    index?: string;
    key?: string;
    childrens?: RouteDefinition[];
}

export const routes: RouteDefinition[] = [
    {
        path: '/login',
        element: <Login />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/apply',
        element: <Register />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/reset-password',
        element: <ResetPassword />,
        key: 'guest',
        guard: GuestGuard,
    },

    {
        path: '/',
        element: <Layout />,
        index: 'dashboard',
        key: 'broker',
        guard: UserGuard,
        childrens: [
            {
                path: 'dashboard',
                element: <Homepage />,
            },
            {
                path: 'faqs',
                element: <Faqs />,
            },
            {
                path: 'models',
                element: <AiModels />,
            },
            {
                path: 'demo-requests',
                element: <DemoRequests />,
            },
            {
                path: 'claire-glen-ivy',
                element: <ClaireGlenIvy />,
            },
            {
                path: 'marketing',
                element: <MarketingView />,
            },
            {
                path: 'costs',
                element: <ClientCostsPage />,
            },
            {
                path: 'subscriptions',
                element: <LeoSubscriptionsPage />,
            },
            {
                path: 'comparison-boards',
                element: <LeoComparisonBoards />,
            },
            {
                path: 'leo-chat',
                element: <LeoChatPage />,
            },
            {
                path: 'expert-partners',
                element: <ExpertPartners />,
            },
            {
                path: 'costs/:clientId',
                element: <ClientCostsDetailsPage />,
            },
            {
                path: 'need-help',
                element: <UsersNeedHelp />,
            },
            {
                path: 'tips-feedback',
                element: <TipsFeedback />,
            },
            {
                path: 'sofia-exceptions',
                element: <KnowledgeBaseExceptionsTester />,
            },
            {
                path: 'users',
                element: <UsersPage />,
            },
            {
                path: 'prompts',
                element: <PromptsListPage />,
            },
            {
                path: 'prompts/new',
                element: <CreatePromptPage />,
            },
            {
                path: 'prompts/:promptId',
                element: <PromptDetailPage />,
			},
			{
                path: 'agent-clients',
                element: <AgentClientsPage />,
            },
        ],
    },
];
